import { buildProps } from "@xplus/utils/props";
import { sizes } from "../../image/src/image";
import type { ExtractPropTypes } from "vue";
export const tableImageProps = buildProps({
  /** 地址 */
  src: {
    type: String,
    required: true,
  },
  errorSrc: {
    type: String,
  },
  size: {
    type: String,
    values: sizes,
    default: "xs",
  },
  replace: {
    type: String,
  },
  handleUrl: {
    type: Function,
  },
} as const);

export type TableImageProps = ExtractPropTypes<typeof tableImageProps>;
